import * as BuildingPlans from "../../../ApartmentFinderConfig/BuildingPlans"
import { colours } from "../../../ApartmentFinderConfig/colours"
import { useRef, useLayoutEffect } from "react"

import {
  getNestedObject,
  getShapes,
  returnSVGID,
  useAvailableApartments,
  UseSvg
} from "../Utils/hooks"
import { blockInfo } from "../../../ApartmentFinderConfig/blockInfo"
import { BuildingElevationComponent } from "../../../ApartmentFinderConfig/BuildingElevations"
import { useStore } from "../../../state/store"
import { BuildingDiagramLayout } from "../../../ApartmentFinderConfig/FilteringUI.style"
import { ElevationSvgJsx } from "./ElevationJsx"

function SitePlan() {
  const svgref = useRef()
  const setActiveBlock = useStore(state => state.setActiveBlock)
  const favouritesActive = useStore(state => state.favouritesActive)
  const setCurrentCameraPositionID = useStore(state => state.setCurrentCameraPositionID)
  const bathroomCounts = useStore(state => state.bathroomCounts)
  const bedroomCounts = useStore(state => state.bedroomCounts)
  const aspects = useStore(state => state.aspects)

  const storredObjects = {
    ID: useAvailableApartments().map(obj => obj.PlotNumberPlanning)
  }

  const handleClick = e => {
    let target = returnSVGID(e.target.parentElement.parentElement.parentElement.id, 1)
    setCurrentCameraPositionID(`block${target.toUpperCase()}`)
    setActiveBlock(target)
  }

  useLayoutEffect(() => {
    //   // console.log(svgref.current);
    const all = UseSvg(svgref.current.children, "")
    const buttons = UseSvg(svgref.current.children, "hidden_buttons")

    const apt_no = getNestedObject(svgref.current.children, "apt_no_")

    //**  All */
    all.map(c => (c.style.cursor = "pointer"))
    all.map(c => (c.style.userSelect = "none"))

    //**  Invisible buttons */
    buttons.map(c => (c.style.opacity = 0))
    buttons.map(c => (c.onclick = e => handleClick(e)))

    //**  Apartment Numbers */
    apt_no.map(c => c.setAttribute("text-align", "center"))
    getShapes(apt_no).map(c => c.setAttribute("fill", colours.primaryUI))
    getShapes(apt_no).map(c => c.setAttribute("stroke", colours.primaryUI))
    getShapes(apt_no).map(c => c.setAttribute("text-anchor", "right"))

    apt_no.map(
      c =>
        (c.lastChild.textContent = storredObjects.ID.filter(i =>
          i.includes(returnSVGID(c.id, 2))
        ).length)
    )
  }, [bedroomCounts, favouritesActive, aspects, bathroomCounts, storredObjects])

  return <BuildingPlans.SvgSitePlan ref={svgref} />
}

function SvgJSX({ isCard }) {
  const activeBlock = useStore(state => state.activeBlock)
  const apartmentFinderActive = useStore(state => state.apartmentFinderActive)

  const setActiveBlock = useStore(state => state.setActiveBlock)
  const setCurrentCameraPositionID = useStore(state => state.setCurrentCameraPositionID)

  let handleClick = () => {
    setCurrentCameraPositionID(`blockF`)
    setActiveBlock("J")
  }
  let handleClickH = () => {
    setCurrentCameraPositionID(`blockH`)
    setActiveBlock("H")
  }

  if (!isCard) {
    if (activeBlock && apartmentFinderActive) {
      return (
        <BuildingDiagramLayout style={{ width: "80%" }}>
          <ElevationSvgJsx activeBlock={activeBlock} />
        </BuildingDiagramLayout>
      )
    } else
      return (
        <BuildingDiagramLayout style={{ width: "90%" }}>
          <SitePlan />
          <div
            onClick={() => {
              handleClick()
            }}
            style={{
              position: "absolute",
              height: "50px",
              transform: "translate(-150px,  -60px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "grey",
              fontSize: "40px",
              width: "50px",
              backgroundColor: "#7AA9A8",
              border: "2px solid black"
            }}
          >
            J
          </div>
          <div
            onClick={() => {
              handleClickH()
            }}
            style={{
              position: "absolute",
              height: "50px",
                     transform: "translate(30px,  -100px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "grey",
              fontSize: "40px",
              width: "50px",
              backgroundColor: "#7AA9A8",
              border: "2px solid black"
            }}
          >
            H
          </div>
        </BuildingDiagramLayout>
      )
  } else return <ElevationSvgJsx activeBlock={activeBlock} isCard={isCard} />
}

//?  TODO -- STATIC */
export function StaticElevationSvgJsx({ isCard, activeBlock, floor }) {
  const svgref = useRef()
  const selectedFavourite = useStore(state => state.selectedFavourite)

  const returnFloorNumber = id => {
    return Number(id.split("_")[2])
  }

  const isHabitable = v => {
    return (
      blockInfo[activeBlock].habitableFloors.includes(returnFloorNumber(v)) ||
      isNaN(returnFloorNumber(v))
    )
  }

  useLayoutEffect(() => {
    if (svgref.current) {
      let floor_buttons = getNestedObject(svgref.current.children, "floor_button")
      let floor_no = getNestedObject(svgref.current.children, "floor_no")
      let apt_no = getNestedObject(svgref.current.children, "apt_no")
      let apt_circle = getNestedObject(svgref.current.children, "apt_circle")
      let floor_circle = getNestedObject(svgref.current.children, "floor_circle")
      //** All */
      const all = UseSvg(svgref.current.children, "")

      all.map(c => c.setAttribute("stroke", colours.offWhite))
      all.map(c => c.setAttribute("strokeWidth", "2.5"))
      //**Floor Circle */

      floor_circle.map(c => c.setAttribute("fill", colours.primaryUI))
      floor_circle.map(c => c.setAttribute("strokeWidth", "1"))
      //**Apartment Circle */
      apt_circle.map(c => c.setAttribute("fill-opacity", 0))
      apt_circle.map(c => c.setAttribute("stroke-opacity", 0))

      //**Apartment Number */
      apt_no.map(c => c.setAttribute("fill", colours.secondaryUI))
      apt_no.map(c => (c.style.cursor = "auto"))
      apt_no.map(c => c.setAttribute("strokeWidth", "0"))
      apt_no.map(c => (c.style.userSelect = "none"))
      apt_no.map(c => (c.style.display = "none"))
      //**floor number */
      floor_no.map(c => c.setAttribute("fill", colours.offWhite))
      floor_no.map(c => c.setAttribute("strokeWidth", "0"))
      floor_no.map(c => (c.style.cursor = "auto"))
      floor_no.map(c => (c.style.userSelect = "none"))
      //**Apartment Circle */
      floor_buttons.map(c => (c.style.display = "none"))
      floor_buttons.map(c => (c.style.display = "none"))
      floor_buttons = floor_buttons.filter(a => isHabitable(a.id))
      floor_buttons.map(c => (c.style.display = ""))
      floor_buttons.map(c => (c.style.cursor = "pointer"))
      floor_buttons.map(c => (c.style.userSelect = "none"))
      // ** Floor Buttons */
      floor_buttons.map(fb =>
        fb.setAttribute(
          "fill",
          returnFloorNumber(fb.id) === Number(floor) ? colours.primaryUI : colours.primaryUILighter
        )
      )
      floor_buttons.map(fb =>
        fb.setAttribute(
          "opacity",

          returnFloorNumber(fb.id) === Number(floor) ? 0.7 : 0
        )
      )
    }
  }, [activeBlock, selectedFavourite])

  return <BuildingElevationComponent buildingID={activeBlock} ref={svgref} />
}

export default SvgJSX
